import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'areaMedianIncome',
    label: 'AMI',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'agencyCaseNumber',
    label: 'Agency Case Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'agencyCaseNumberIssueDate',
    label: 'Agency Case Number Issue Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hfaInfo',
    label: 'Housing Finance Agency (HFA)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorCodes',
    label: 'Investor Code',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'leadSource',
    label: 'Lead Source',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanProgramIdentifiers',
    label: 'Loan Program Identifier',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanWorkflow',
    label: 'Loan Workflow',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'minimumResidualIncome',
    label: 'Minimum Residual Income',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'nationalHousingActSection',
    label: 'National Housing Act Section',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'governmentRefinancePurpose',
    label: 'Government Refinance Purpose',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fha203kConsultantId',
    label: '203k Consultant Identifier',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fhaBorrowerCertification',
    label: 'FHA Borrower Certification',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const additionalLoanInfoForm = {
  name: FormNames.ADDITIONAL_LOAN_INFO,
  label: 'Additional Loan Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
